/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
function Bronnen() {
  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>Bronnen</h1>
          <p>
            Onderstaande tabel bevat algemene bronnen van informatie voor genealogisch onderzoek die ik zelf heb geraadpleegd tijdens mijn onderzoek. Daarbij staat wat meer
            informatie vermeld van hoe waardevol deze bron is gebleken voor mijn eigen onderzoek. De genoemde prijzen dateren van 2023.
          </p>

          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Bron</th>
                  <th>Toelichting</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <a href="https://www.ancestry.com/">Ancestry</a>
                  </td>
                  <td className="left">
                    Een site waar je eerst een account nodig hebt. De site lijkt vooral Amerikaans georiënteerd, en zodra je iets wil bekijken moet je premium member worden.
                    Redelijk commercieel en prijzig.
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="https://cbg.nl">CBG</a>
                  </td>
                  <td className="left">
                    Nederlandse digitale bibliotheek voor familiegeschiedenis. Zij bieden een dagpas voor onbeperkte toegang gedurende 1 dag, die kost &euro;7,05. De moeite waard
                    om rond te kijken.
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="https://filae.com">Filae</a>
                  </td>
                  <td className="left">
                    Deze site is vooral op Frankrijk (of eigenlijk alleen maar) georiënteerd. Maar ook hier moet je eerst premium member worden. Je kunt kiezen voor een
                    subscription van 1 maand, voor &euro;14. Daarmee is het wel wat goedkoper dan andere commerciële sites.
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="https://nl.geneanet.org/">Gegeanet</a>
                  </td>
                  <td className="left">
                    Ook een genealogie site, maar minder commercieel ingesteld dan anderen. Premium account is &euro;12,50 / kwartaal. Hier lijkt redelijk veel informatie op te
                    staan, meer dan bij andere commerciële varianten.
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="https://www.myheritage.com/">My Heritage</a>
                  </td>
                  <td className="left">
                    My Heritage is een van de grootste en bekendste genealogie sites. Maar ze zijn dan waarschijnlijk ook de duurste, met een prijs van &euro;259 per jaar (eerste
                    jaar &euro;159) voor het complete abonnement. Abonnementen per maand doen ze niet aan. Het lastige met dergelijke sites is dat je eigenlijk van te voren wil
                    weten wat je zou kunnen gaan vinden, maar daar kom je dus pas achter als je al minimaal &euro;159 lichter bent. Het is dan ook aan te raden eerst hier genoemde
                    alternatieven te onderzoeken.
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="https://gallica.bnf.fr/">Nationale bibliotheek van Frankrijk</a>
                  </td>
                  <td className="left">Uitgebreide informatie met Franse gegevens, en alles is gratis.</td>
                </tr>
                <tr>
                  <td>
                    <a href="https://archives.somme.fr/">Somme</a>
                  </td>
                  <td className="left">
                    Site waar oude doopregisters e.d. te vinden zijn. Nog geen echte waardevolle informatie kunnen vinden, maar ziet er wel veelbelovend uit (en gratis).
                  </td>
                </tr>
                <tr>
                  <td>
                    <a href="https://www.genealogieonline.nl/">Genealogie Online</a>
                  </td>
                  <td className="left">
                    Ook een commerciële site, met een abonnement van &euro;49 per jaar. Deze site is vooral gericht op Nederland dus weinig zinvol als je naar afstammelingen in
                    andere landen wil zoeken.
                  </td>
                </tr>

                <tr>
                  <td>
                    <a href="https://www.yory.nl/bronnen-bij-stamboomonderzoek/">Yori stamboomonderzoek</a>
                  </td>
                  <td className="left">Wat hints en tips over stamboomonderzoek, en wat links naar interessante sites.</td>
                </tr>
                <tr>
                  <td>
                    <a href="https://www.delpher.nl/">Delpher</a>
                  </td>
                  <td className="left">Een zoekmachine voor met name Nederlandse boeken.</td>
                </tr>
                <tr>
                  <td>
                    <a href="https://genver.nl/">GenVer</a>
                  </td>
                  <td className="left">
                    Overzicht van gescande trouwboeken, doopboeken etc. van Nederlandse provincies. Zeer geschikt om te zoeken in scans die nog niet getranscribeerd zijn.
                  </td>
                </tr>

                <tr>
                  <td>
                    <a href="https://www.archives-nationales.culture.gouv.fr/">Nationaal Frans Archief</a>
                  </td>
                  <td className="left">Nationale archief van Frankrijk.</td>
                </tr>
                <tr>
                  <td>
                    <a href="https://www.familysearch.org/search/location/continental-europe/france">Family search</a>
                  </td>
                  <td className="left">
                    Ook voor deze site moet je je aanmelden. Maar na aanmelding is er een vrij rijk archief van met name Franse namen. Tot nu toe het beste archief wat ik heb
                    kunnen vinden.
                  </td>
                </tr>

                <tr>
                  <td>
                    <a href="/stamboom/bronnen/1993 - A van Zoest - Genealogie van een Familie Ladage.pdf">Genealogie Fam. Ladage</a>
                  </td>
                  <td className="left">Genealogie van een Familie Ladage, geschreven door A van Zoest in 1993</td>
                </tr>
                <tr>
                  <td>
                    <a href="/stamboom/bronnen/2022 - Parenteel Abraham La Daque.pdf">Parenteel Abraham La Daque</a>
                  </td>
                  <td className="left">Parenteel te vinden op https://www.kuipersgenealogie.nl/</td>
                </tr>
                <tr>
                  <td>
                    <a href="https://stadsarchief.rotterdam.nl/zoek-en-ontdek/stamboom/">Stadsarchief Rotterdam</a>
                  </td>
                  <td className="left">Nuttig archief bij het zoeken op de familienaam 'Ladage', omdat die vooral uit Rotterdam komen.</td>
                </tr>
                <tr>
                  <td>
                    <a href="https://www.nationaalarchief.nl/onderzoeken/zoekhulpen/doop-trouw-en-begraafboeken-van-zuid-holland-voor-1811#districten">Nationaal archief</a>
                  </td>
                  <td className="left">Nuttig archief waar veel Nederlandse Doop-, Trouw- en Begraafboeken te vinden zijn.</td>
                </tr>
                <tr>
                  <td>
                    <a href="https://www.wiewaswie.nl/nl/zoeken/">Wie was wie</a>
                  </td>
                  <td className="left">Eenvoudig doorzoekbaar archief wat een goed startpunt is voor veel onderzoek.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Bronnen;
